import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M12 15v4.555c-.344.032-.687.066-1.03.1a5 5 0 0 0-4.46 4.376C6.17 26.851 6 30.195 6 34.065c0 1.387.022 2.619.066 3.694a7 7 0 0 0 6.385 6.689C16.665 44.816 20.514 45 24 45c3.485 0 7.333-.184 11.545-.552a7 7 0 0 0 6.385-6.677c.047-1.104.07-2.372.07-3.803 0-3.844-.168-7.156-.505-9.939a5 5 0 0 0-4.46-4.373c-.344-.035-.69-.068-1.035-.1V15c0-6.627-5.373-12-12-12S12 8.373 12 15Zm9.6 17.2a1 1 0 0 1 .4.8v4a2 2 0 1 0 4 0v-4a1 1 0 0 1 .4-.8 4 4 0 1 0-4.799 0ZM20 15v4.061a130.474 130.474 0 0 1 8 0V15a4 4 0 0 0-8 0Z",
      clipRule: "evenodd"
    }
  )
);
var SvgLockedFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var LockedFilled_default = SvgLockedFilled;

export { LockedFilled_default as default };
